<template>
  <div>
    <h1>JobScheduleScreen</h1>
  </div>
</template>

<script>
export default {
  created() {
    // Update store
    var payload = {
      headerType: "needHeader",
      currentPage: "JobScheduleScreen",
    };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
};
</script>

<style>
</style>